'use es6';

import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "upgrade-point" */'./UpgradePointButton');
export default Loadable({
  loader,
  LoadingComponent: () => null
});